import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependency'
import { getTemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
<wa-divider class="divider-line"></wa-divider>
`
class NavHeaderPrimaryDivider extends HTMLElement {
  constructor() {
    super()
    
    tryLoadDependencies(document, [WebAwesomeComponent.Divider])
    
    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderPrimaryDivider connectedCallback', this)
  }
}

if (!customElements.get('ts-navheader-divider')) {
  customElements.define('ts-navheader-divider', NavHeaderPrimaryDivider)
}
export { NavHeaderPrimaryDivider }
